import { Link } from 'react-router-dom';

import { Label, LABEL_TYPE } from '@/components/generic';
import { RightArrowIcon } from '@/resources';
import { PathItem } from '@/types';

import { BREADCRUMB_CONTAINER_STYLES, ICON_STYLE, TEXT_COLOR } from './breadcrumb-config';

type BreadcrumbProps = {
  icon: JSX.Element;
  iconPath?: string;
  path: PathItem[];
  className?: string;
};

export const Breadcrumb = ({ icon, path, className = '', iconPath }: BreadcrumbProps) => {
  return (
    <div className={`${BREADCRUMB_CONTAINER_STYLES} ${className}`}>
      <Link to={iconPath ?? '/'} className={TEXT_COLOR}>
        {icon}
      </Link>
      {path.map((pathName, index) => (
        <div key={index} className={BREADCRUMB_CONTAINER_STYLES}>
          <RightArrowIcon className={`${ICON_STYLE} ${TEXT_COLOR}`} />
          {index < path.length - 1 ? (
            <Link to={pathName.url ?? '/'} className={TEXT_COLOR}>
              <Label text={pathName.label} type={LABEL_TYPE.PARAGRAPH2} />
            </Link>
          ) : (
            <div>
              <Label text={pathName.label} type={LABEL_TYPE.PARAGRAPH2_BOLD} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
